import { GET_PRODUCTS, SET_PRODUCTS } from '../actions/actionTypes';

const initialState = {
  list: [],
  isLoading: false,
  isLoaded: false
};

const productsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCTS:
      return { ...state, isLoading: true };
    case SET_PRODUCTS:
      return {
        ...state,
        list: action.products,
        isLoaded: true,
        isLoading: false
      };
    default:
      return state;
  }
};

export default productsReducer;
